"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
var configBuilder_1 = require("../config/configBuilder");
var lodash_1 = require("lodash");
function deenumerateConfig(obj) {
    var currentConfig = obj.config;
    Object.defineProperty(obj, 'config', {
        enumerable: false
    });
    obj.config = currentConfig;
}
exports.deenumerateConfig = deenumerateConfig;
function findConfig(obj) {
    var config = obj.config;
    return Object.assign({
        ignorePaths: [],
        optionalPartialConfig: {}
    }, config);
}
exports.findConfig = findConfig;
exports.ID_KEY = '__@@_id_key';
var ID = 0;
function deenumerateIDKey(obj) {
    var currentKey = obj[exports.ID_KEY];
    Object.defineProperty(obj, exports.ID_KEY, {
        enumerable: false
    });
    obj[exports.ID_KEY] = currentKey;
}
var Transerializable = /** @class */ (function () {
    function Transerializable() {
        this[_a] = ID++;
    }
    /* tslint:enable */
    Transerializable.build = function (arg) {
        if (arg === void 0) { arg = {}; }
        var obj = new this();
        deenumerateIDKey(obj);
        var _a = arg, json = _a.json, fields = __rest(_a, ["json"]);
        var partial = __1.setKeysFromPartial(obj, fields);
        return Transerializable.parseJson2(partial, json);
    };
    Transerializable.parseJson = function (json) {
        if (json === void 0) { json = {}; }
        var obj = new this();
        return Transerializable.parseJson2(obj, json);
    };
    Transerializable.parseJson2 = function (obj, json) {
        if (json === void 0) { json = {}; }
        deenumerateIDKey(obj);
        if (lodash_1.isEmpty(json)) {
            return obj;
        }
        var name = obj.constructor.name;
        if (!Transerializable.ConfigMap[name]) {
            var config = this.prototype.config;
            var _a = (config) ? config : findConfig(obj), ignorePaths = _a.ignorePaths, optionalPartialConfig = _a.optionalPartialConfig;
            Transerializable.ConfigMap[name] =
                configBuilder_1.buildConfig(obj, json, ignorePaths, optionalPartialConfig);
        }
        return configBuilder_1.applyConfig(obj, Transerializable.ConfigMap[name], json);
    };
    Transerializable.prototype.toJSON = function () {
        var _a = this, config = _a.config, _b = exports.ID_KEY, idKey = _a[_b], copy = __rest(_a, ["config", typeof _b === "symbol" ? _b : _b + ""]);
        return copy;
    };
    var _a;
    _a = exports.ID_KEY;
    /* tslint:disable */
    Transerializable.ConfigMap = {};
    return Transerializable;
}());
exports.Transerializable = Transerializable;
function stripSpecialFields(obj) {
    return lodash_1.reduce(Object.keys(obj), function (acc, key) {
        if (key !== 'config' && key !== 'constructor' && key !== exports.ID_KEY) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
}
exports.stripSpecialFields = stripSpecialFields;
//# sourceMappingURL=transerializable.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/get-or/dist/trans/transerializable.js
 ** module id = 1055
 ** module chunks = 0
 **/